import { sortLayersByOrder } from "../../configuration/utils.js";
const rapid60 = values => {
  const layers = [];

  // BODY
  layers.push({ folder: "BODY", imageName: values.EV_NUM_CONECTORES });

  // RIGHT SIDE
  if (values.EV_TIPO_CONECTOR_RIGHT_SIDE) {
    layers.push({
      folder: "RIGHT_SIDE",
      imageName:
        values.EV_LONGITUD_MANGUERA + "_" + values.EV_TIPO_CONECTOR_RIGHT_SIDE,
    });
  }

  // LEFT SIDE
  if (values.EV_TIPO_CONECTOR_LEFT_SIDE) {
    layers.push({
      folder: "LEFT_SIDE",
      imageName:
        values.EV_LONGITUD_MANGUERA + "_" + values.EV_TIPO_CONECTOR_LEFT_SIDE,
    });
  }

  // OTHERS
  const partes = [];

  if (values.EV_CONTACTLESS === true) partes.push("CONTACTLESS");
  if (values.EV_TIPO_CONECTOR_LEFT_FRONT)
    partes.push(values.EV_TIPO_CONECTOR_LEFT_FRONT);
  if (values.EV_PULSADOR_EMERGENCIA === true)
    partes.push("PULSADOR_EMERGENCIA");

  let layer = partes.length > 1 ? partes.join("_") : partes[0] || "";

  if (!layer || layer === "AC_22") {
    // Si no hay partes, o solo AC_22 → LEFT_FRONT como capa normal
    if (values.EV_TIPO_CONECTOR_LEFT_FRONT) {
      layers.push({
        folder: "LEFT_FRONT",
        imageName: values.EV_TIPO_CONECTOR_LEFT_FRONT,
      });
    }
  } else {
    if (layer === "CONTACTLESS") {
      layer = "CONTACTLESS_LECTOR";
    }

    layers.push({
      folder: "OTHERS",
      imageName: layer,
    });
  }

  if (values.EV_MOBILE) {
    layers.push({ folder: "OTHERS", imageName: "MOBILE" })
  }

  // ORDEN PERSONALIZADO
  const layerOrder = [
    "BODY",
    "LEFT_SIDE",
    "RIGHT_SIDE",
    "LEFT_FRONT",
    "OTHERS:CONTACTLESS",
    "OTHERS:CONTACTLESS_LECTOR",
    "OTHERS:PULSADOR_EMERGENCIA",
    "OTHERS",
  ];

  return sortLayersByOrder(layers, layerOrder);
};

export default rapid60;
